export default __webpack_public_path__ + "static/media/GButton.173a1f1b.jpg";